<!-- <div class="row justify-content-lg-center"> -->

		<div class="col-lg-3">
			<div class="kt-portlet">
				<div class="kt-portlet__body">
					<div class="kt-pricing-1">
						<div class="kt-pricing-1__items row">
							<div class="kt-pricing-1__item col-lg-12">
								<div class="kt-pricing-1__visual">
									<div class="kt-pricing-1__hexagon1"></div>
									<div class="kt-pricing-1__hexagon2"></div>
									<span class="kt-pricing-1__icon kt-font-brand">
										<i class="fa {{menuIcon}}"></i>
									</span>
								</div>
								<span class="kt-pricing-1__price">{{menuTitle}}</span>
								<h2 class="kt-pricing-1__subtitle">{{menuSubTitle}}</h2>
								<!-- <span class="kt-pricing-1__description">
									<span>Lorem ipsum aret</span>
									<span>sed do eiusmod</span>
									<span>magna siad ali</span>
								</span> -->
								<div class="kt-pricing-1__btn">
									<button type="button" (click)="btnClick()"
											class="btn btn-brand btn-custom btn-pill btn-wide btn-uppercase btn-bolder btn-sm">
											{{menuButtonTitle}}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

<!-- </div> -->
